import { render, staticRenderFns } from "./ProductRecommendationsProvider.vue?vue&type=template&id=63291030&"
import script from "./ProductRecommendationsProvider.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendationsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports